import * as React from 'react'
import { Box } from 'grommet'
import { SectionTitleStyle, SectionTextStyle } from './style'

export default class RiskTitle extends React.Component {

  public render() {

    return (
      <Box>
        <SectionTitleStyle>Bem vindo a área de Risco!</SectionTitleStyle>
        <SectionTextStyle bold size = "14px">Escolha para qual seção deseja ir:</SectionTextStyle>
      </Box>
    )
  }
}
